export function croppingErrorText(errorText: string): string {
  return errorText.length > 300 ? `${errorText.slice(0, 300)}...` : errorText;
}
